import instance from "api/instance";

// Get all fee groups
const getFeeGroups = async () => {
  const response = await instance.get("/admin/crypto-payout-fee-groups");
  if (response.status === 200) {
    return response.data;
  }
  return Promise.reject(response.data);
};

// Get simple reseller list for selection
const getResellersSimple = async () => {
  const response = await instance.get("/admin/resellers-simple");
  if (response.status === 200) {
    return response.data;
  }
  return Promise.reject(response.data);
};

// Create fee group
const createFeeGroup = async (data) => {
  const response = await instance.post("/admin/crypto-payout-fee-groups", data);
  if (response.status === 201 || response.status === 200) {
    return response.data;
  }
  return Promise.reject(response.data);
};

// Update fee group (FULL EDIT)
const updateFeeGroup = async (data) => {
  const response = await instance.patch("/admin/crypto-payout-fee-groups", data);
  if (response.status === 200) {
    return response.data;
  }
  return Promise.reject(response.data);
};

// Delete fee group
const deleteFeeGroup = async (id) => {
  const response = await instance.delete("/admin/crypto-payout-fee-groups", {
    data: { id }
  });
  if (response.status === 200) {
    return response.data;
  }
  return Promise.reject(response.data);
};

const cryptoPayoutFeeGroupsService = {
  getFeeGroups,
  getResellersSimple,
  createFeeGroup,
  updateFeeGroup,
  deleteFeeGroup,
};

export default cryptoPayoutFeeGroupsService;